import React from 'react';
import MacroRing from '../../nutrition/MacroRing';
import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';

const MacroRingCard = ({ data }) => {
  return (
    <div className="bg-zinc-900/60 border border-zinc-800 rounded p-4 space-y-3" data-testid="card-macro-ring">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-wider text-zinc-500">Today's macros</span>
        <Link to="/nutrition" className="text-xs text-primary hover:underline">Open Nutrition →</Link>
      </div>
      <MacroRing totals={data?.totals || data} targets={data?.targets} />
    </div>
  );
};

export default MacroRingCard;
